import { ImportBranchDto } from './importBranchDto'
import { PermissionDto } from './permissionDto'

export class PersonVTS2AccessDto {
  permissions: PermissionDto[] = []
  defaultImportBranch?: ImportBranchDto | null
  isConformitySigner?: boolean = false
}
